export default __webpack_public_path__ + "static/media/js_icon.22ad1d02.png";